import { render, staticRenderFns } from "./AppWx.vue?vue&type=template&id=8f1ebbba&scoped=true"
import script from "./AppWx.vue?vue&type=script&lang=js"
export * from "./AppWx.vue?vue&type=script&lang=js"
import style0 from "./AppWx.vue?vue&type=style&index=0&id=8f1ebbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1ebbba",
  null
  
)

export default component.exports